import { nip19 } from 'nostr-tools';
import { Link, useParams } from 'react-router-dom';
import NotFound from './NotFound';
import PackDetailPage from './PackDetailPage';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { SiteFooter, SiteHeader } from '@/components/SiteHeader';
import { FOLLOW_PACK_KIND } from '@/lib/followPacks';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
    case 'nprofile':
      return <ProfileStub identifier={identifier} />;
    case 'naddr': {
      const { kind, pubkey, identifier: d } = decoded.data;
      if (kind === FOLLOW_PACK_KIND) {
        return <PackNaddrRedirect pubkey={pubkey} d={d} />;
      }
      return <NotFound />;
    }
    case 'note':
    case 'nevent':
    default:
      return <NotFound />;
  }
}

/** naddr for a kind 39089 pack → render the pack detail directly. */
function PackNaddrRedirect({ pubkey, d }: { pubkey: string; d: string }) {
  void pubkey;
  void d;
  return <PackDetailPage naddrOverride />;
}

function ProfileStub({ identifier }: { identifier: string }) {
  let pubkey = '';
  try {
    const decoded = nip19.decode(identifier);
    if (decoded.type === 'npub') pubkey = decoded.data;
    else if (decoded.type === 'nprofile') pubkey = decoded.data.pubkey;
  } catch { /* handled by caller */ }

  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="container flex-1 py-16">
        <Card className="mx-auto max-w-md border-dashed">
          <CardContent className="px-8 py-12 text-center">
            <p className="text-muted-foreground">
              Follow Party is about packs, not profiles. This user{pubkey ? ` (${pubkey.slice(0, 8)}…)` : ''} hasn’t got a dedicated page here.
            </p>
            <Button asChild className="mt-4 rounded-full">
              <Link to="/">Browse packs instead</Link>
            </Button>
          </CardContent>
        </Card>
      </main>
      <SiteFooter />
    </div>
  );
}
